<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>工单管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">工单管理</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="工单状态">
                  <el-select
                    v-model="ruleForm.name"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="待处理" value="0"></el-option>
                    <el-option label="处理中" value="1"></el-option>
                    <el-option label="已处理" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column label="工单编号" align="center" prop="id">
          </el-table-column>
          <el-table-column
            prop="complainTypeName"
            label="投诉原因"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="content" label="状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status === 0" class="blueColor">待处理</div>
              <div v-else-if="scope.row.status === 1" class="yellowColor">
                处理中
              </div>
              <div v-else-if="scope.row.status === 2" class="greenColor">
                已处理
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="gmtCreate" label="是否上传证据" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.uploadEvidence == 0 ? "否" : "是" }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="submitAt" label="创建时间" align="center">
          </el-table-column>
          <el-table-column prop="complainantName" label="投诉人" align="center">
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="160"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn"
                  @click="goDetail1(scope.row)"
                  v-if="scope.row.status != 2"
                >
                  处理工单
                </div>
                <div
                  class="operateBtn"
                  @click="goDetail1(scope.row)"
                  v-if="scope.row.status == 2"
                >
                  查看详情
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
import Template from "../template/template.vue";
export default {
  components: {
    system,
    Template,
  },
  data() {
    return {
      leftList: this.Plugins.customerData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetForm() {
      this.page = 1;
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList(val) {
      if (val === "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        status: this.ruleForm.name,
      };
      this.$axios
        .post(`/admapi/job/litigationOrder/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    goDetail1(row) {
      this.$router.push({
        path: "/workOrderDetail",
        query: { id: row.id },
      });
    },
  },
};
</script>
<style scoped></style>
